import { createApp } from "vue";
import router from "@/router";
import store from "./store";
import App from "./App.vue";
import element from 'element-plus'
import locale from 'element-plus/lib/locale/lang/zh-cn' //中文
// 引入 vue-meta-info
import MetaInfo from "vue-meta-info";

// 全局引入 ElementPlus
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

const app = createApp(App);
createApp(App).use(router).use(element, { locale }).mount('#app') // 中文版element
app.use(router).use(store).use(MetaInfo).use(ElementPlus).mount("#app");
